import './../styles/contact.scss';
import SendMail from "../components/sendmail/Sendmail";

function Contacts (){
    return (
    <>
    <div className="app">
        <br/> <br/> <br/> <br/>
        <SendMail/>
    </div>
    </>
    );
}

export default Contacts;